import ModalWindow from 'components/molecules/ModalWindow'
import { CONSTS } from 'config/objectConst'
import { useActionCreators, useAppSelector } from 'shared/hooks'

import { api } from '../api'
import { useCurrentId } from '../hooks'
import { actions } from '../model/slice'
import { selectors } from '../utils/selectors'

export function DeleteMessage() {
	const conversation = useCurrentId()
	const [sendDelete] = api.useDeleteMessageMutation()

	const id = useAppSelector(selectors.deleteMessage)
	const { resetDeleteMessage } = useActionCreators(actions)

	const deleteMessage = () =>
		sendDelete({
			conversation,
			id
		})
			.unwrap()
			.catch(console.error)
			.finally(resetDeleteMessage)

	return (
		<ModalWindow
			closeHandler={resetDeleteMessage}
			closeText='No'
			confirmHandler={deleteMessage}
			confirmText='Yes'
			{...CONSTS.confirmationDialogs[1.13]}
			open={Boolean(id)}
		/>
	)
}
